import axios from 'axios';

class SugerenciasDataService {
  getAll() {
    return axios.get(`/api/sugerencias`);
  }
  
  getWip() {
    return axios.get(`/api/sugerencias/wip`);
  }

  get(id) {
    return axios.get(`/api/sugerencias/${id}`);
  }

  create(data) {
    return axios.post(`/api/sugerencias`, data);
  }

  update(id, data) {
    return axios.put(`/api/sugerencias/${id}`, data);
  }

  delete(id) {
    return axios.delete(`/api/sugerencias/${id}`);
  }

  deleteAll() {
    return axios.delete(`/api/sugerencias`);
  }
}

export default new SugerenciasDataService();